module.exports = __webpack_public_path__ + "static/media/banner.10bd73a3.png";